<template>
  <div class="modal fade" id="cancel-subscription" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div :class="['modal-dialog',
     {'technical-reason-dialog': currentReason.id === 0 && show.solution},
     {'save-money-dialog': currentReason.id === 1 && show.solution},
     {'not-need-dialog': currentReason.id === 2 && show.solution},
     {'switch-package-dialog': currentReason.id === 3 && show.solution},
     {'other-reason-dialog': currentReason.id === 4 && show.solution},
     {'reason-list-dialog': show.list},
     {'sure-dialog': show.sureModal}]" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span><svg class="icon"><use
            xlink:href="#icon-close"></use></svg></span></button>
          <h4 v-if="show.solution" class="text-center">{{ currentReason.reason }}</h4>
          <h4 v-if="show.sureModal" class="text-center">{{ $t('proceedTitle') }}</h4>
        </div>

        <template v-if="show.list">
          <div class="modal-body">
            <p class="sorry-message">{{ $t('sorryMessage') }}</p>
            <p v-for="(reason, index) in $t('cancelReasonList')" @click="chooseReason(reason)" class="reason-list">
              <span :class="[ currentReason.id === index ? 'chosen-icon' : 'circle-span']">
                <img src="/static/img/affiliate/agree_policy_2x.png" v-show="currentReason.id === index">
              </span>{{ reason.reason }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" aria-label="Close" class="keep-subscription">{{ $t('keepSubscription') }}</button>
            <button type="button" class="continue-btn" @click="showSolution">
              <span class="fill-bg"></span>
              <span>{{ $t('continueBtn') }}</span>
              </button>
          </div>
        </template>

        <template v-else-if="show.solution">
          <div class="modal-body">
            <p>{{ currentReason.solution }}</p><span class="email" v-if="currentReason.id === 0">iplexservice@gmail.com</span>
            <p v-if="currentReason.id === 4" class="custom-reason-box">
              <textarea name="customReason" rows="3" :placeholder="$t('enterReason')" v-model="customReason"></textarea>
              <span>{{ customReasonLength }}/300</span>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" aria-label="Close" class="keep-subscription">{{ $t('keepSubscription') }}</button>
            <button type="button" class="continue-btn" @click="showSureModal">
              <span class="fill-bg"></span>
              <span>{{ $t('continueBtn') }}</span>
            </button>
          </div>
        </template>

        <template v-else-if="show.sureModal">
          <div class="modal-body">
            <p>{{ $t('cancelSubscriptionNotice') }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" aria-label="Close" class="keep-subscription">{{ $t('keepSubscription') }}</button>
            <button type="button" class="cancel-subscription-btn" @click="cancelSubscription">
              <span class="fill-bg"></span>
              <span>{{ $t('cancelSubscription') }}</span>
            </button>
          </div>
        </template>

        <template v-else-if="show.cancelling">
          <div class="modal-body">
            <spinner-component :show="show.cancelling" class="spinner-component"></spinner-component>
          </div>
        </template>

        <template v-else-if="show.cancelSuccess">
          <div class="modal-body">
            <p class="text-center">{{ $t('cancelSuccess') }}</p>
          </div>
          <div class="modal-footer sure-btn-box">
            <button type="button" data-dismiss="modal" aria-label="Close" class="sure-btn">{{ $t('sure') }}</button>
          </div>
        </template>

        <template v-else-if="show.cancelFailed">
          <div class="modal-body">
            <p class="text-center">{{ cancelError }}</p>
          </div>
          <div class="modal-footer sure-btn-box">
            <button type="button" data-dismiss="modal" aria-label="Close" class="sure-btn">{{ $t('sure') }}</button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import locales from './lang'
  import $ from 'jquery'
  import SpinnerComponent from './../../Spinner.vue'

  export default {
    name: 'cancel-subscription-modal',
    locales,
    components: {SpinnerComponent},
    props: {
      subscriptionInfo: {
        type: Object,
        required: true
      }
    },
    data: function () {
      return {
        currentReason: this.$t('cancelReasonList')[0],
        show: {
          list: true,
          solution: false,
          cancelling: false,
          cancelSuccess: false,
          cancelFailed: false,
          sureModal: false
        },
        customReason: '',
        cancelling: false,
        cancelSuccess: false,
        cancelError: ''
      }
    },
    computed: {
      customReasonLength() {
        return this.customReason.length
      },
      cancelReason() {
        if (this.currentReason.id !== 4) {
          return this.currentReason.reason
        } else {
          return this.customReason
        }
      }
    },
    watch: {
      customReason() {
        if (this.customReasonLength >= 300) {
          this.customReason = this.customReason.substring(0, 300)
        }
      }
    },
    mounted() {
      let currentVm = this
      $('#cancel-subscription').on('hidden.bs.modal', function () {
        currentVm.resetData()
      })
    },
    methods: {
      chooseReason(reason) {
        this.currentReason = reason
      },
      resetData() {
        this.currentReason = this.$t('cancelReasonList')[0]
        this.customReason = ''
        this.cancelling = false
        this.cancelError = ''
        for (let showKey in this.show) {
          this.show[showKey] = false
        }
        this.show.list = true
        if (this.cancelSuccess) {
          this.$store.dispatch('getUserInformation')
          this.$store.dispatch('getSubscription')
        }
        this.cancelSuccess = false
      },
      showSureModal() {
        this.show.solution = false
        this.show.sureModal = true
      },
      cancelSubscription() {
        this.show.sureModal = false
        this.show.cancelling = true
        this.cancelling = true
        this.$http.post('api/topup-subscription/cancel?web=1', {
          subscription_id: this.subscriptionInfo.subscription_id,
          cancel_reason: this.cancelReason
        }).then((response) => {
          if (response.data.code === 0) {
            this.show.cancelling = false
            this.show.cancelSuccess = true
            this.cancelling = false
            this.cancelSuccess = true
          } else {
            this.show.cancelling = false
            this.cancelling = false
            this.show.cancelFailed = true
            this.cancelError = response.body.message
          }
        })
      },
      showSolution() {
        this.show.list = false
        this.show.solution = true
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/reset-modal";
  @import "../../../assets/scss/mixins/button";
  @import "../../../assets/scss/mixins/gradient";


  .modal-dialog {
    @include modal-dialog($height: 2rem, $phone-height: 2.2rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.1rem) 0 0 -45% !important;
    }
  }

  .technical-reason-dialog {
    @include modal-dialog($height: 5.17rem, $phone-height: 5.38rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.69rem) 0 0 -45% !important;
    }
  }

  .save-money-dialog {
    @include modal-dialog($height: 5.17rem, $phone-height: 4.56rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.28rem) 0 0 -45% !important;
    }
  }

  .not-need-dialog {
    @include modal-dialog($height: 4.33rem, $phone-height: 5.2rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.6rem) 0 0 -45% !important;
    }
  }

  .switch-package-dialog {
    @include modal-dialog($height: 5.24rem, $phone-height: 4.28rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.14rem) 0 0 -45% !important;
    }
  }

  .other-reason-dialog {
    @include modal-dialog($height: 7.8rem, $phone-height: auto);
    @media (max-width: 767px) {
      margin: 50px 0 50px -45% !important;
    }
  }

  .reason-list-dialog {
    @include modal-dialog($height: 5.15rem, $phone-height: 5.5rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.75rem) 0 0 -45% !important;
    }
  }

  .sure-dialog {
    @include modal-dialog($height: 5.24rem, $phone-height: 5.4rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.7rem) 0 0 -45% !important;
    }
  }

  .modal-content {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.71px;
    line-height: .28rem;
    padding: .2rem .4rem;
    .email {
      color: #416CF8;
    }

  }

  .modal-header {
    h4 {
      padding-top: .2rem;
      font-size: .24rem;
      font-weight: 700;
      margin: 0 0 .6rem 0;
      @media (max-width: 767px) {
        margin: 0 .2rem .5rem 0;
      }
    }
  }

  .modal-body {
    .sorry-message {
      margin: 0 0 .6rem 0;
    }
    .reason-list {
      position: relative;
      padding: 0 0 0 .3rem;
      cursor: pointer;
      text-align: left;
      span {
        position: absolute;
        top: 0;
        left: 0;
        img {
          width: .14rem;
          height: .14rem;
          margin: .03rem 0;
        }
      }
      .chosen-icon {
        border: 0;
      }
      .circle-span {
        height: .14rem;
        width: .14rem;
        border: .01rem solid #295FFD;
        border-radius: 50%;
        top: .07rem;
      }
    }
    .spinner-component {
      margin: 0 auto;
    }
    .custom-reason-box {
      margin: .4rem 0 0 0;
      position: relative;
      font-size: 0;
      padding: 0;
      display: block;
      span {
        color: #acb7cc;
        font-size: .12rem;
        line-height: .12rem;
        position: absolute;
        bottom: .26rem;
        right: .1rem;
      }
      textarea {
        width: 100%;
        height: 2.5rem;
         @media (max-width: 767px) {
          height:1.7rem;
        }
        @media (max-width: 280px) {
          height:1.3rem;
        }
        resize: none;
        padding: .1rem;
        outline: 0;
        font-size: .14rem;
        border: .01rem solid #acb7cc;
        &:focus, &:active {
          outline: 0;
        }
        &::-webkit-input-placeholder {
          color: #acb7cc;
        }
        &:-moz-placeholder {
          color: #acb7cc;
        }
        &::-moz-placeholder {
          color: #acb7cc;
        }
        &:-ms-input-placeholder {
          color: #acb7cc;
        }
      }
    }
  }

  .modal-footer {
    // position: absolute;
    width: 100%;
    padding: .4rem 0 .4rem 0;
    @media (max-width: 767px) {
      padding: .4rem 0 .2rem 0;
    }
    @media (max-width: 320px) {
      padding: .2rem 0 .2rem 0;
    }
    left: 0;
    bottom: 0;
    .keep-subscription {

      @include modal-button();
      display: block;
      margin: 0 auto .2rem auto;
      min-width: 2.8rem;
      @media (max-width: 767px) {
        min-width: 0;
        width: 100%;
      }
    }
    @mixin gradient-border-btn() {
      display: block;

      margin: 0 auto .4rem auto;
      @include gradient-background($deg: 90deg, $bottom-color: #416CF8 0%, $top-color: #EC55FF 100%);
      position: relative;
      min-width: 2.8rem;
      @media (max-width: 767px) {
        min-width: 0;
        width: 100%;
      }
      height: .5rem;
      line-height: .5rem;
      border-radius: .5rem;
      span {
        text-align: center;
        display: inline-block;
        position: relative;
        top: 0;
        left: 0;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        border-radius: .5rem;
        font-size: .2rem;
        letter-spacing: 1.17px;
        @include gradient-font($deg: 90deg, $bottom-color: #416CF8 0%, $top-color: #EC55FF 100%);
      }
      span.fill-bg {
        margin: 1px;
        background: #fff;
        position: absolute;
        top: 0;
        left: 0;
      }
      @media (max-width: 1228px) {
        margin: 0 auto;
        height: .5rem;
        line-height: .5rem;
      }
    }
    .continue-btn, .cancel-subscription-btn {
      @include gradient-border-btn();
      margin: .2rem auto 0 auto;
    }
    .sure-btn {
      @include modal-button();
      margin: 0 auto;
    }
    @media (max-width: 767px) {
      text-align: center;
      button {
        margin: 0 auto;
        display: block;
      }
      .continue-btn {
        margin: .2rem auto 0 auto;
      }
    }
  }
  .sure-btn-box {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?3b58cbac